import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { User } from '../../models/user';
import { UserService } from '../../core/services/user.service';

@Component({
  selector: 'app-select-user-dialog',
    templateUrl: './select-user-dialog.component.html',
    styleUrls: ['./select-user-dialog.component.css']
})
export class SelectUserDialogComponent implements OnInit {
    users: User[];
    selectedUser: User;

    constructor(public dialogRef: MatDialogRef<SelectUserDialogComponent>, private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data: string) {

        this.userService.getAll().subscribe((users: User[]) => {
            this.users = users.filter(u => u.role.name == data && !u.displayedUser.includes(data));
            this.selectedUser = users[0];
        });
  }

  ngOnInit() {
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedUser.displayedUser);
  }

  onDismiss(): void {
    this.dialogRef.close();
  }
}
